module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/paper_desktop-45431e73a35457eb80d754972be48f4e.png";